/**
 * A path into the sample document, typed freely with suggestions from
 * `GET /evaluators/paths` (the dataset's own paths, plus what a run adds), grouped
 * by where each comes from (Input, Output, Metadata…). The path is the label; on the right, the value it reads in the chosen sample, or
 * how many items have it when not all do.
 * Used by the configure screen and by the new-experiment inline fix.
 */

import type { FocusEventHandler } from "react";
import { Combobox } from "@/components/ui/combobox";
import { oneLine, valueAt } from "@/lib/json";
import type { PathInfo } from "./types";
import { coverage, sourceOf } from "./variables";

export function PathInput({
  label,
  value,
  paths,
  sample,
  onChange,
  onFocus,
  invalid,
}: {
  label: string;
  value: string;
  paths: PathInfo[];
  /** The sample document, to show what each path reads. */
  sample?: Record<string, unknown> | undefined;
  onChange: (path: string) => void;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  invalid?: boolean;
}) {
  const options = paths.map((p) => ({
    value: p.path,
    section: sourceOf(p.path),
    hint: coverage(p) || (sample ? oneLine(valueAt(sample, p.path) ?? undefined, 32) : undefined),
  }));
  return (
    <Combobox
      label={label}
      value={value}
      options={options}
      placeholder="e.g. input.question"
      invalid={invalid}
      onFocus={onFocus}
      onChange={onChange}
    />
  );
}
